import { LookingToContext } from "../context/LookingToContext";
import EditableDataContainer from "../containers/EditableDataContainer";
import { purchaseComparePageValidationSchema } from "../util/comparePageValidationSchema";
import { FastTrackView } from "./FastTrackView";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import React from "react";
import { getParametizedQuoteEndpoint } from "../util/fetch/getParametizedQuoteEndpoint";
import { processQuoteResult } from "../util/fetch/processQuoteResult";
import { LoadingIndicator } from "../atoms/LoadingIndicator";
import { PURCHASEIRQCompareView } from "./PURCHASEIRQCompareView";
import { isDataValidForPurchaseOrBuild } from "../util/fetch/isDataValidForPurchaseOrBuild";
import { isPlannedClosingDateLessThanThirteenDaysAway } from "../util/fetch/isPlannedClosingDateLessThanThirteenDaysAway";
import { connect } from "react-redux";
import { mapPageToProps } from "../util/mapPageToProps";
import { withToastContext } from "../util/withToastContext";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { CountyLimitsContext } from "../context/CountyLimitsContext";

class FastTrackPage extends React.Component {
  static contextType = CountyLimitsContext;

  constructor() {
    super();
    this.state = {
      quotes: null,
      insufficientData: null,
      lookingTo: "Build",
    };
    this.runQuotesQuery = this.runQuotesQuery.bind(this);
    this.getPageData = this.getPageData.bind(this);
  }

  runQuotesQuery = (lookingTo, data) => {
    this.setState({ lookingTo });
    const parametizedQuoteEndpoint = getParametizedQuoteEndpoint(
      lookingTo,
      data
    );
    return processQuoteResult.call(this, parametizedQuoteEndpoint);
  };

  componentDidMount() {
    if (!isDataValidForPurchaseOrBuild(this.props.data)) {
      this.setState({ insufficientData: true });
      if (
        isPlannedClosingDateLessThanThirteenDaysAway(
          this.props.data.plannedClosingDate
        )
      ) {
        this.props.toastContext.openToast({
          message:
            "You must select a planned closing date more than 15 days away.",
        });
      }
      this.context.fetchCountyLimits();
      return;
    }

    this.getPageData();
  }

  getPageData = async () => {
    await this.context.fetchCountyLimits();
    this.runQuotesQuery(this.props.data.lookingTo ?? "Build", this.props.data);
  };

  render() {
    const { countyLimits } = this.context;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    if (this.state.insufficientData === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching loan options..." />
        </div>
      );
    }

    if (this.state.insufficientData === true) {
      return (
        <div className="page-wrapper">
          <LookingToContext.Provider value={this.state.lookingTo}>
            <EditableDataContainer
              id="fasttrack"
              mutateRedux="always"
              validationSchema={purchaseComparePageValidationSchema}
              isStep
            >
              <FastTrackView
                lookingTo={this.state.lookingTo}
                runQuotesQuery={this.runQuotesQuery}
                content={contentMap.BuildIrqComparePage}
                navigationsAway={customNavigationMap.BuildIrqComparePage}
              />
            </EditableDataContainer>
          </LookingToContext.Provider>
        </div>
      );
    }

    return (
      <div className="page-wrapper">
        <LookingToContext.Provider value={this.state.lookingTo}>
          <EditableDataContainer
            id="fasttrack"
            mutateRedux="always"
            isStep
            validationSchema={purchaseComparePageValidationSchema}
          >
            <PURCHASEIRQCompareView
              lookingTo={this.state.lookingTo}
              runQuotesQuery={this.runQuotesQuery}
              quotes={this.state.quotes}
              content={contentMap.BuildIrqComparePage}
              navigationsAway={customNavigationMap.BuildIrqComparePage}
            />
          </EditableDataContainer>
        </LookingToContext.Provider>
      </div>
    );
  }
}

export default connect(mapPageToProps("fasttrack"))(
  withToastContext(withRouterUtilities(FastTrackPage))
);
